/**
 * Email Action Modal Form Component
 * used when the state of a record changes, which also fires off an email.
 * The modal is used as confirmation of the state change, and also to
 * collect form input for the email (notes etc.)
 */

import TextArea from '@/gf/components/TextArea'
import Spinner from '@/gf/components/Spinner'
import ModalForm from '@/gf/components/ModalForm'

import { EmailActionModalFormC } from '../../types'

const EmailActionModalForm: EmailActionModalFormC = ({
  open,
  onClose,
  title,
  onSubmit,
  submitButtonText = 'Submit',
  isWaiting,
  emailText,
  setEmailText,
  sendEmailCheckbox,
  setSendEmailCheckbox,
  children,
}) => (
  <ModalForm
    open={open}
    onClose={onClose}
    title={title}
    onSubmit={onSubmit}
    submitButtonText={submitButtonText}
    submitButtonDisabled={isWaiting}
  >
    {isWaiting ? (
      <Spinner />
    ) : (
      <>
        {children}
        <div className="relative flex items-start my-2">
          <div className="flex items-center h-5">
            <input
              checked={sendEmailCheckbox}
              onChange={(e) => {
                setSendEmailCheckbox(e.target.checked)
              }}
              id="send-approve-email"
              name="send-approve-email"
              type="checkbox"
              className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
            />
          </div>
          <div className="ml-3 text-sm">
            <label htmlFor="send-approve-email" className="text-gray-700">
              Notify Customer (sends email)
            </label>
          </div>
        </div>
        {sendEmailCheckbox && (
          <>
            <p>Additional comments for the customer:</p>
            <p>ATTENTION: The customer will see these comments.</p>
            <TextArea
              className="mt-2"
              value={emailText}
              onChange={(e) => setEmailText(e.target.value)}
            />
          </>
        )}
      </>
    )}
  </ModalForm>
)

export default EmailActionModalForm
